import * as React from "react";
import {useMemo} from "react";
import {classNames, layout, PushButton, useStorageItemBlob, View, ViewContent} from "@variocube/cube-ui";
import {style, stylesheet} from "typestyle";
import background from "./img/background.png";
import {useLocalization} from "../i18n";

interface HomeViewProps {
    onStart: () => void;
}

export function HomeView({onStart}: HomeViewProps) {
    const {t} = useLocalization();

    const backgroundImageBlob = useStorageItemBlob("backgroundImage");
    const backgroundImageUrl = useMemo(() => backgroundImageBlob && URL.createObjectURL(backgroundImageBlob), [backgroundImageBlob]);
    const customBackground = backgroundImageUrl && style({backgroundImage: `url("${backgroundImageUrl}")`});

    return (
        <View className={styles.home}>
            <ViewContent className={classNames(layout.horizontal, layout.center, layout.alignEnd, layout.paddingLarge, customBackground)}>
                <PushButton primary onClick={onStart} className={styles.button}>{t("Start")}</PushButton>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    home: {
        background: `url('${background}') no-repeat center center`,
        backgroundSize: "cover"
    },
    button: {
        border: "2px solid #fff",
        boxShadow: "0 1px 0.5rem 0 rgba(0, 0, 0, 0.5)",
        fontSize: "1.5em"
    }
});
